<template>
  <div id="company-display-available-brands" class="col">
    <div class="row-12">
      <h6 class="mb-0 mt-1 mt-sm-0 mt-md-1 mt-lg-2 font-weight-bold text-nowrap text-medium">Available Brands</h6>
      <div class="sep-small mb-4 mb-md-3" />
    </div>
    <div id="brand-list" class="row-12 d-flex flex-wrap">
      <div v-if="!brands || (brands && brands.length < 1)">No brands available at this time</div>
      <template v-for="(brand, index) in brands" v-else>
        <div v-if="!brand.deleted_at" :key="brand.name + index" class="brand-item mr-3 mb-3">
          <img :id="brand.name + brand.id + index" :src="brand.logoLink" :alt="brand.name" class="img-fluid" />
          <BTooltip :target="brand.name + brand.id + index" triggers="hover">
            {{ brand.name }}
          </BTooltip>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    brands: { type: Array, require: true },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
#company-display-available-brands {
  min-width: 15rem;
  #brand-list {
    .brand-item {
      display: flex;
      flex-direction: column;
      text-align: center;
      width: 50px;

      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
